var map = {
	"./Analytics.md": 319,
	"./IoTCore.md": 320,
	"./QuickSight.md": 321,
	"./Sagemaker.md": 322,
	"./apiGateway.md": 92,
	"./api_gateway.md": 323,
	"./cognito.md": 88,
	"./dynamodb.md": 87,
	"./forecast.md": 97,
	"./kinesis.md": 91,
	"./lakeFormation.md": 94,
	"./lambdaTensorflow.md": 90,
	"./lambda_image_metadata.md": 324,
	"./lambda_rec_data.md": 325,
	"./lambda_stock_data.md": 326,
	"./redshift.md": 96,
	"./s3.md": 86,
	"./ses.md": 89,
	"./shield.md": 93,
	"./sns.md": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 318;